module.exports = __webpack_public_path__ + "img/circle_actived.0b763587.svg";